import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();

  const handleBooking = () => {
    navigate('/booking');
  };

  return (
    <section className="py-32 px-6 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/52e8782eb753438a21615fc8e39d8c13.jpg"
          alt="Happy pets background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#9B4C9A]/85 via-[#C77DFF]/80 to-[#FF9BC8]/85"></div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2
          className="text-6xl lg:text-7xl font-bold text-white mb-8 tracking-wider animate-fade-in-up"
          style={{ fontFamily: 'Pacifico, cursive', textShadow: '0 4px 20px rgba(0,0,0,0.2)' }}
        >
          Give Your Pet the Best
        </h2>

        <p className="text-3xl lg:text-4xl text-white mb-12 leading-relaxed animate-fade-in-up animate-delay-200" style={{ fontFamily: 'Pacifico, cursive', textShadow: '0 2px 15px rgba(0,0,0,0.2)' }}>
          Schedule your first visit today and see
          <br />
          the difference love and care can make
        </p>

        <button 
          onClick={handleBooking}
          className="bg-white text-[#9B4C9A] px-12 py-5 rounded-full text-xl font-bold hover:bg-[#FFF5F9] transition-all hover:scale-105 shadow-2xl inline-flex items-center gap-3 whitespace-nowrap cursor-pointer animate-scale-in animate-delay-400"
        >
          Book Your Visit Today
          <i className="ri-arrow-right-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
